// IMPORTANT: Sync changes with apps/extranet/e2e/auth.fixture.ts
export const KEYCLOACK_MOCK_EMAIL = {
  DEFAULT: "default@test.com",
  NEGATIVE_SEGMENTATION: "negative-segmentation@test.com",
  DOCS_TO_SIGN: "docs-to-sign@test.com",
  DOCS_TO_SIGN_CRITICAL: "adh-critical-unsigned-docs@test.com",
} as const

export type KeycloakMockEmail =
  (typeof KEYCLOACK_MOCK_EMAIL)[keyof typeof KEYCLOACK_MOCK_EMAIL]
